import i18n from '../../translations/i18n'

const energyCertifications = [
  {
    label: i18n.t('apartment.list.information.energyCertNotRequired'),
    value: i18n.t('apartment.list.information.energyCertNotRequired')
  },
  {
    label: 'A',
    value: 'A'
  },
  {
    label: 'B',
    value: 'B'
  },
  {
    label: 'C',
    value: 'C'
  },
  {
    label: 'D',
    value: 'D'
  },
  {
    label: 'E',
    value: 'E'
  },
  {
    label: 'F',
    value: 'F'
  },
  {
    label: 'G',
    value: 'G'
  },
  {
    label: 'A2007',
    value: 'A2007'
  },
  {
    label: 'B2007',
    value: 'B2007'
  },
  {
    label: 'C2007',
    value: 'C2007'
  },
  {
    label: 'D2007',
    value: 'D2007'
  },
  {
    label: 'E2007',
    value: 'E2007'
  },
  {
    label: 'F2007',
    value: 'F2007'
  },
  {
    label: 'G2007',
    value: 'G2007'
  },
  {
    label: 'A2013',
    value: 'A2013'
  },
  {
    label: 'B2013',
    value: 'B2013'
  },
  {
    label: 'C2013',
    value: 'C2013'
  },
  {
    label: 'D2013',
    value: 'D2013'
  },
  {
    label: 'E2013',
    value: 'E2013'
  },
  {
    label: 'F2013',
    value: 'F2013'
  },
  {
    label: 'G2013',
    value: 'G2013'
  },
  {
    label: 'A2018',
    value: 'A2018'
  },
  {
    label: 'B2018',
    value: 'B2018'
  },
  {
    label: 'C2018',
    value: 'C2018'
  },
  {
    label: 'D2018',
    value: 'D2018'
  },
  {
    label: 'E2018',
    value: 'E2018'
  },
  {
    label: 'F2018',
    value: 'F2018'
  },
  {
    label: 'G2018',
    value: 'G2018'
  }
]
export { energyCertifications }
